import format from 'date-fns/format';

const GameId = require('gid-decoder/GidDecoder');
const dateFormatString = 'MMM d, yyyy';

const gameStatePropHelper = (data) => {
    const {
        gameData: {
            game = {}
        } = {}, playIndex
    } = data || {};
    const isAtBat = (typeof playIndex !== 'undefined');
    const { pk, gameStatus, datetime, teams } = game;
    let inningState;
    let currentInning;

    if (!isAtBat) {
        inningState = game?.inningState;
        currentInning = game?.currentInning;
    } else {
        const { allPlays } = game;
        const { about } = allPlays[playIndex] || {};
        inningState = about?.halfInning == 'top' ? 'Top' : 'Bottom';
        currentInning = about?.inning;
    }

    const status = gameStatus || '';
    const id = GameId(game?.id)?.gid || '';

    if (status === 'In Progress' && inningState) {
        inningState = inningState + ' ' + currentInning;
    } else {
        let split;
        switch (true) {
            case status?.indexOf('Challenge'):
            case status?.indexOf('Review'):
                split = inningState.split(' ');
                inningState = split[1] || split[0];
                break;
            case status.indexOf('Early'):
            case status === 'Game Over':
                inningState = 'Game Over';
                break;
            case status === 'Scheduled':
                inningState = status;
                break;
            default:
                inningState = inningState?.split(' ')?.[0] + ' ' + currentInning;
        }
    }

    // Get match up info
    const trackingDate = format(new Date(datetime?.dateTime), dateFormatString) || '';
    const names = [
        teams.away.name,
        'at',
        teams.home.name
    ].join(' ');

    const gamedayMatchup = [
        names,
        trackingDate
    ].join(': ');

    return {
        prop34: id,
        prop44: pk,
        prop36: inningState,
        prop40: gamedayMatchup
    };
};

export default gameStatePropHelper;
